import { mergeSx } from "#hooks/mergeSx";
import type { DateTime } from "@dmca/utils/luxon";
import type { SxProps, Theme } from "@mui/material";

export type SharedDatePickerProps = {
    anchorEl: HTMLElement | null;
    type: "date" | "time" | "datetime";
    onClose?: () => void;
    onChange?: (date: DateTime | null) => void;
    dateFormat?: string;
    value?: DateTime;
    sx?: SxProps<Theme>;
};
export function useSharedProps(props: SharedDatePickerProps) {
    return {
        dateFormat: "YYYY-MM-DDTHH:mm:ss",
        ...props,
        sx: mergeSx(
            {
                maxWidth: "100%",
                minWidth: "inherit",
                display: "block",
                "& > *": {
                    maxWidth: "100%",
                },
                "& .MuiDateCalendar-root": {
                    width: "100%",
                    maxWidth: "320px",
                    "& .MuiYearCalendar-root": {
                        width: "inherit",
                        maxWidth: "inherit",
                    },
                },
                "& .MuiTimeClock-root": {
                    flexDirection: "column-reverse",
                },
                "& .MuiPickersArrowSwitcher-root": {
                    position: "relative",
                    justifyContent: "end",
                },
                "& .MuiClock-root": {
                    my: 0,
                },
                "& .MuiDateTimePickerToolbar-dateContainer span": {
                    fontSize: "1.5rem",
                },
                "& .MuiDateTimePickerToolbar-timeContainer span": {
                    fontSize: "1.5rem",
                },
                "& span[class*='MuiDateTimePickerToolbar-separator']": {
                    lineHeight: 3,
                    fontSize: "1.5rem",
                },
            },
            props.sx
        ),
    };
}
